// ─── Query Keys ───────────────────────────────────────────────────────────────

import type { SearchUserPreferencesParams } from '@klareospace/pharos-lib-front-utils';

export const userPreferenceKeys = {
  all: ['user-preferences'] as const,
  list: (params: SearchUserPreferencesParams): readonly unknown[] => [...userPreferenceKeys.lists(), params] as const,
  lists: (): readonly string[] => [...userPreferenceKeys.all, 'list'] as const,
};
